import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Loader2, ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { AuditResult } from "@/pages/LeadGenAuditTool";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LeadGenAuditShared() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Shared Lead Generation Audit | WebsiteTech.pro";
    (async () => {
      try {
        const { data } = await axios.get(`${API}/leadgen/audit/share/${token}`);
        setData(data);
      } catch (e) {
        setError(e?.response?.data?.detail || "Audit not found or has expired.");
      } finally { setLoading(false); }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex items-center justify-between mb-6">
          <Link to="/lead-generation/audit" className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-slate-900" data-testid="leadgen-shared-back">
            <ArrowLeft size={14} /> Run a new audit
          </Link>
          {data?.created_at && (
            <div className="text-xs text-slate-500">Generated {new Date(data.created_at).toLocaleString()}</div>
          )}
        </div>

        {loading && (
          <div className="text-center py-24" data-testid="leadgen-shared-loading">
            <Loader2 size={28} className="animate-spin mx-auto text-slate-400" />
            <div className="text-sm text-slate-500 mt-3">Loading shared audit…</div>
          </div>
        )}

        {error && !loading && (
          <div className="text-center py-24" data-testid="leadgen-shared-error">
            <div className="text-2xl font-bold text-slate-900">{error}</div>
            <p className="text-slate-600 mt-2">The link may have expired. Run a fresh audit any time.</p>
            <Button asChild className="mt-6 bg-slate-900 hover:bg-slate-800 rounded-full">
              <Link to="/lead-generation/audit">Run a new audit</Link>
            </Button>
          </div>
        )}

        {data && !loading && (
          <>
            <div className="mb-8 text-center">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 border border-blue-200 text-blue-800 text-[11px] font-bold uppercase tracking-widest">Shared audit</div>
              <h1 className="text-4xl font-black text-slate-900 mt-3">Lead Generation Audit</h1>
              <p className="text-slate-600 mt-2 text-sm">For <span className="font-mono text-slate-800">{data.url}</span></p>
            </div>
            <AuditResult result={data.result} shareUrl={`${window.location.origin}/lead-generation/audit/${data.share_token}`} />
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
